import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import React, { useState } from 'react'

import { membersDashboard } from 'rails_routes'
import { Button, DropdownMenu } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

interface ICHRADashboardHeaderProps {
  balance: string;
  allowance: string;
  planYears: number[];
  currentPlanYear: number;
}

const ICHRADashboardHeader: React.FC<ICHRADashboardHeaderProps> = ({
  balance,
  allowance,
  planYears,
  currentPlanYear
}) => {
  const { assign } = useWindowLocation()

  const [selectedPlanYear, setSelectedPlanYear] = useState<number>(currentPlanYear)

  const handlePlanYearChange = (year: number) => {
    setSelectedPlanYear(year)
    // Reload the page with the new plan year
    assign(membersDashboard.ichra({ query: { plan_year: year } }))
  }

  return (
    <div className='flex flex-col bg-white border rounded-lg shadow-sm p-4 w-full h-40 justify-between'>
      <div className='flex flex-row justify-between items-start w-full gap-4'>
        <div className='flex flex-col gap-y-1'>
          <span className='text-xs text-gray-500'>Available balance</span>
          <span className='text-3xl font-medium'>{balance}</span>
        </div>
        <div className='flex items-start'>
          <DropdownMenu
            onOpenChange={() => {}}
            trigger={({ open }) => (
              <Button
                variant='secondary'
                rightIcon={open ? ChevronUpIcon : ChevronDownIcon}
              >
                Plan year {selectedPlanYear}
              </Button>
            )}
          >
            {planYears.map(year => (
              <DropdownMenu.Item
                key={year}
                onSelect={() => handlePlanYearChange(year)}
              >
                Plan year {year}
              </DropdownMenu.Item>
            ))}
          </DropdownMenu>
        </div>
      </div>
      <div className='flex flex-col gap-y-1'>
        <span className='text-xs text-gray-500'>Employer allowance</span>
        <span className='flex items-baseline'>
          <span className='text-md'>{allowance}</span>
          {allowance !== 'Unavailable' && <span className='text-xs text-gray-500 ml-1'>/ mo</span>}
        </span>
      </div>
    </div>
  )
}

export default ICHRADashboardHeader
